export default __webpack_public_path__ + "3a661bfb48c41810300e9f85725e4f01.svg";